import { ViewModel } from "../mvvm/ViewModel.js";
import { PlanCatalog } from "../models/PlanCatalog.js";
/**
 * PlanCatalogViewModel loads a site's hosting-plan catalog from the backend
 * (DB-backed) and exposes it as observable state. It is initialized with the
 * static bootstrap catalog so a View always has plans to render, and it falls
 * back on error or empty response. Successful loads replace prices from
 * platform_stripe_prices via the public plans API (#744).
 */
export class PlanCatalogViewModel extends ViewModel {
    client;
    slug;
    constructor(client, slug) {
        super({ loading: false, error: null, plans: PlanCatalog.plans });
        this.client = client;
        this.slug = slug;
    }
    async load() {
        await this.run(async () => {
            const dtos = await this.client.getPlans(this.slug);
            const plans = PlanCatalog.fromDTOs(dtos);
            this.setState({ plans: plans.length > 0 ? plans : PlanCatalog.plans });
        }, "Failed to load plans.", { onError: () => ({ plans: PlanCatalog.plans }) });
    }
}
//# sourceMappingURL=PlanCatalogViewModel.js.map